export default {
  tab: "Demandes d'inscription",
  subtitle: "Les personnes qui ont demandé à rejoindre l'organisation par son formulaire public.",
  loadFailed: "Les demandes n'ont pas pu être chargées.",
  loadMore: 'Afficher plus',
  filters: {
    label: 'Statut des demandes',
    pending: 'En attente',
    approved: 'Acceptées',
    rejected: 'Refusées',
    all: 'Toutes',
  },
  status: {
    pending: 'En attente',
    approved: 'Acceptée',
    rejected: 'Refusée',
    decided: 'Traitée',
  },
  table: {
    applicant: 'Demandeur',
    submittedAt: 'Envoyée le',
    status: 'Statut',
    workspace: 'Espace',
    joined: 'A rejoint',
    invited: 'Invitation envoyée',
    open: 'Voir la demande',
  },
  empty: {
    pending: 'Aucune demande en attente',
    approved: 'Aucune demande acceptée',
    rejected: 'Aucune demande refusée',
    all: "Aucune demande pour l'instant",
    description: 'Les demandes envoyées par le formulaire public apparaissent ici.',
  },
  form: {
    title: 'Formulaire public',
    open: 'Ouvert',
    closed: 'Fermé',
    openDescription: "Toute personne qui a cette adresse peut demander à rejoindre l'organisation.",
    closedDescription: "Le formulaire n'accepte aucune demande. Celles déjà reçues restent ici.",
    noAddress: 'Aucune adresse publique ne peut être déterminée pour cette organisation.',
    copy: "Copier l'adresse",
    copied: 'Adresse copiée dans le presse-papiers',
    copyFailed: "L'adresse n'a pas pu être copiée",
    settings: 'Paramètres du formulaire',
    loadFailed: "Les paramètres du formulaire n'ont pas pu être chargés.",
  },
  settings: {
    title: 'Paramètres du formulaire',
    enabled: 'Formulaire ouvert',
    enabledHint:
      "Fermé, son adresse répond comme si l'organisation n'avait pas de formulaire. Les demandes déjà reçues restent à traiter.",
    schema: 'Questions supplémentaires',
    schemaNone: 'Aucune : adresse e-mail et nom seulement',
    schemaFields: 'aucune question | {count} question | {count} questions',
    schemaMissing: "Un schéma qui n'est plus disponible",
    schemaHint:
      "Les questions viennent d'un schéma de métadonnées « demande d'inscription » de l'organisation, écrit par l'équipe Videas.",
    termsUrl: 'Page des conditions',
    termsUrlHint:
      'Renseignée, le demandeur doit cocher une case acceptant ces conditions. Laissez vide pour ne rien demander.',
    saved: 'Paramètres du formulaire enregistrés',
    invalid: 'Ces paramètres ont été refusés.',
    failed: "Les paramètres n'ont pas pu être enregistrés.",
  },
  detail: {
    back: 'Retour aux demandes',
    notFound: "Cette organisation n'a pas de demande à cette adresse.",
    submittedAt: 'Envoyée le {date}',
    locale: 'Formulaire rempli en {locale}',
    termsAccepted: 'Conditions acceptées le {date}',
    unverified: "Adresse non vérifiée : c'est l'invitation envoyée à l'acceptation qui la confirme.",
    answers: 'Réponses',
    noAnswers: "Le formulaire ne posait pas d'autre question.",
    yes: 'Oui',
    no: 'Non',
    opensInNewTab: "S'ouvre dans un nouvel onglet",
    decision: 'Décision',
    approvedBy: 'Acceptée par {name} le {date}',
    approvedOn: 'Acceptée le {date}',
    rejectedBy: 'Refusée par {name} le {date}',
    rejectedOn: 'Refusée le {date}',
    decidedOn: 'Traitée le {date}',
    workspace: 'Espace de travail',
    workspaceGone: "L'espace n'existe plus",
    joinedOn: "A rejoint l'organisation le {date}",
    notJoined: "N'a pas encore accepté l'invitation",
    rejectionMessage: 'Message envoyé au demandeur',
    approve: 'Accepter',
    reject: 'Refuser',
  },
  approve: {
    title: 'Accepter la demande',
    where: 'Où accueillir {name} ?',
    create: 'Créer un nouvel espace de travail',
    existing: 'Ajouter à un espace existant',
    createDenied:
      "Seul un rôle qui peut créer des espaces et gérer tous les espaces peut en créer un ici : personne n'aura de place dans l'espace créé, vous non plus, et il doit rester accessible.",
    name: 'Nom du nouvel espace',
    createHint:
      "Personne n'y aura de place avant que {name} accepte l'invitation. Les rôles qui gèrent tous les espaces y ont accès.",
    pick: 'Espace de travail',
    noWorkspace: "Aucun espace où vous pouvez inviter quelqu'un",
    noMatch: 'Aucun espace ne correspond à cette recherche',
    role: "Rôle dans l'espace",
    answers: 'Réponses du demandeur',
    invitation:
      "Une invitation sera envoyée à {email}. En l'acceptant, la personne rejoint l'organisation comme membre, avec ce rôle dans l'espace.",
    confirm: 'Accepter et inviter',
    success: 'Demande acceptée : une invitation a été envoyée à {email}',
  },
  reject: {
    title: 'Refuser la demande',
    notify: 'Prévenir le demandeur par e-mail',
    notifyOff:
      "Personne ne sera prévenu. C'est ce qu'il faut faire pour une adresse qui est déjà membre, après lui avoir donné sa place dans un espace.",
    message: 'Message (facultatif)',
    messageHint: "Joint à l'e-mail et conservé avec la demande.",
    confirm: 'Refuser la demande',
    success: 'Demande refusée',
    successNotified: 'Demande refusée : {email} en sera informé par e-mail',
  },
  errors: {
    network: 'Le serveur est injoignable. Réessayez.',
    invalid: "Ce choix n'est pas valide.",
    forbidden: "Vous n'avez pas les permissions nécessaires.",
    gone: "Cette demande ou cet espace n'existe plus.",
    conflict: "La demande n'a pas pu être traitée.",
    rateLimited: "Trop d'invitations ont été envoyées récemment. Réessayez plus tard.",
    unavailable: "L'envoi d'e-mails n'est pas disponible : l'invitation ne peut pas partir.",
    generic: 'Une erreur est survenue.',
  },
}
